import StartFreeTrial from "../components/StartFreeTrial";

export default function Start() {
  return <StartFreeTrial />;
}
